/** Web stub — iOS SubscriptionStoreView is native-only. */
export const TERMS_OF_USE_URL = 'https://expensewatcher.com/terms-of-use/';
export const PRIVACY_POLICY_URL = 'https://expensewatcher.com/privacy-policy/';

export const isIOSSubscriptionStoreAvailable = () => false;

export const getIOSActiveSubscriptionProductIds = async () => [];

export const addIOSSubscriptionPurchaseListener = () => () => undefined;

export function IOSSubscriptionStoreView() {
  return null;
}
